import { CommonModule, Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  WritableSignal,
  computed,
  signal,
  ViewChild
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Observable, Subject, debounceTime, lastValueFrom, shareReplay, takeUntil, tap } from 'rxjs';
import {
  MemberService,
  MemberSituationEnum,
} from 'src/app/core/services/member.service';
import { CommonService, DateMode } from 'src/app/core/services/common.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import {
  FreePaymentDataPayload,
  PaymentDataPayload,
  PaymentDataService,
  RecurrentUpgradeTO,
} from 'src/app/core/services/payment-data.service';
import {
  AppToggleButtonComponent,
  BtnToggleOptions,
} from 'src/app/shared/components/app-button-group/app-toggle-button.component';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppCheckboxComponent } from 'src/app/shared/components/app-checkbox/app-checkbox.component';
import {
  AppSelectInputComponent,
  SelectModel,
} from 'src/app/shared/components/app-select-input/app-select-input.component';
import { CardPlanItemsComponent } from 'src/app/shared/components/card-plan-items/card-plan-items.component';
import {
  CreditCardInfoModel,
  PaymentFrequencyId,
  PaymentInfoModel,
  PaymentType,
  PaymentTypeId,
} from 'src/app/shared/models/paymentData';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import { PlanService } from 'src/app/core/services/plan.service';
import { PaymentModalComponent } from 'src/app/shared/components/payment-modal/payment-modal.component';
import { ModalService } from 'src/app/core/services/modal.service';
import {
  AppInputCustomComponent,
  InputMaskTypes,
} from 'src/app/shared/components/app-input-custom/app-input-custom.component';
import {
  AppInputComponent,
  InputType,
} from 'src/app/shared/components/app-input/app-input.component';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { PlanPaymentsService } from 'src/app/core/services/plan-payments.service';
import { DependentsAmountModel, PlanPaymentUpgradeModel } from 'src/app/shared/models/planPaymentsModel';
import { PostPublicMemberPlansModel } from 'src/app/shared/models/memberModel';
import { MemberPlanDetailModel } from 'src/app/shared/models/planModel';
import { UserService } from 'src/app/core/services/user.service';
import { UserModel } from 'src/app/shared/models/userModel';
import { CouponService } from 'src/app/core/services/coupon.service';
import { ModalSelectCouponComponent } from "./modal-select-coupon/modal-select-coupon.component";
import { ValidationErrorsComponent } from 'src/app/shared/components/validation-errors/validation-errors.component';
import { ReplaceTextPipe } from "../../shared/pipe/replace-text.pipe";
import { DependentesModalComponent, DependentToContract, toDependentData } from './dependentes-modal/dependentes-modal.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { JerseySizeService } from 'src/app/core/services/jersey-size.service';
import { JerseyModelService } from 'src/app/core/services/jersey-model.service';
import { QrCodeService } from 'src/app/core/services/qrcode.service';
import { OnlyNumberDirective } from 'src/app/shared/directives/only-number.directive';

@Component({
  selector: 'app-finalizar-pagamento',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppSelectInputComponent,
    AppCheckboxComponent,
    AppButtonComponent,
    AppToggleButtonComponent,
    CustomCurrencyPipe,
    CardPlanItemsComponent,
    RouterModule,
    PaymentModalComponent,
    AppInputCustomComponent,
    AppInputComponent,
    ModalSelectCouponComponent,
    ValidationErrorsComponent,
    ReplaceTextPipe,
    DependentesModalComponent,
    OnlyNumberDirective
  ],
  templateUrl: './finalizar-pagamento.component.html',
  styleUrl: './finalizar-pagamento.component.scss',
})
export class FinalizarPagamentoComponent implements OnInit, OnDestroy {
  labelColor = 'white';
  screenWidth: number;

  InputTypeEnum = InputType;
  InputMaskTypesEnum = InputMaskTypes;
  DateMode = DateMode;

  logoUrl: string = localStorage.getItem('imageLogo') || '';
  pageTitle = 'Finalize o pagamento';
  PaymentType = PaymentType;
  paymentType = PaymentType.CREDITO;
  paymentModalData: any;
  currentUserData: any;
  canChekPix = true;
  showCanUseCardControl = true;
  isForeigner = false;
  discountPlan: any = null;

  private discountPlanPaymentId: string | null = null;
  private lastDiscountAlertKey = '';

  private couponCode: string | null = null;
  private readonly reapplyCoupon$ = new Subject<void>();
  private couponResultCache = new Map<string, { response?: any; error?: string }>();
  private submitInterval?: ReturnType<typeof setInterval>;

  modalId = 'payment-modal';
  couponModalId = 'coupon-modal';
  placeholderCoupon = 'Selecione ou insira um cupom'
  submitCount: number = 0;
  showDependentsOptions = false;
  couponMessage = '';
  memberCoupons: any[] = [];

  couponFormGroup = new FormGroup({ coupon: new FormControl<any>(null) });
  finalizePaymentformGroup = new FormGroup({
    planControl: new FormControl<string>('', Validators.required),
    jerseySizeControl: new FormControl<string>(''),
    jerseyModelControl: new FormControl<string>(''),
    personalizationNameControl: new FormControl<string>(''),
    personalizationNumberControl: new FormControl<string>(''),
    dependentControl: new FormControl<string>('0'),
    frequencyControl: new FormControl<string>('', Validators.required),
    invoiceRecurrenceControl: new FormControl<boolean>(false),
    formOfPaymentControl: new FormControl<string>('', Validators.required),
    creditCardControl: new FormControl<string>(''),
    installments: new FormControl<string>(''),
    dueDayControl: new FormControl<string>('')
  });
  dueDayOptions: SelectModel[] = [
    { code: '', name: '' },
    { code: '1', name: 'Dia 1' },
    { code: '10', name: 'Dia 10' },
    { code: '15', name: 'Dia 15' },
    { code: '20', name: 'Dia 20' },
    { code: '28', name: 'Dia 28' },
  ];

  creditCardformGroup = new FormGroup({
    cardNumberControl: new FormControl<string>(''),
    expirationDateControl: new FormControl<string>(''),
    cvvControl: new FormControl<string>(''),
    cardNameControl: new FormControl<string>(''),
    CPFControl: new FormControl<string>(''),
    numberOfInstallmentsControl: new FormControl<string>(''),
    canUseCardControl: new FormControl<boolean>(true),
  });

  creditCardInfo: WritableSignal<CreditCardInfoModel[]> = signal([]);

  creditCardOptions = computed<SelectModel[]>(() => {
    if (!this.creditCardInfo()) {
      return [];
    }

    return this.creditCardInfo().map((cardInfo) => {
      return {
        code: cardInfo.cardNumber, // Use card number as code
        name: `${cardInfo.cardOperator} - ....${cardInfo.cardNumber.slice(-4)}`,
      } as SelectModel;
    });
  });

  _paymentSummary: any;
  set paymentSummary(value: any) {
    this._paymentSummary = value;

    if (this.couponCode && value?.id && !value.couponApplied) {
      this.reapplyCoupon$.next();
    }

    this.verifyPlanDiscount();
    this.calculateDependentsAmount();
  }
  get paymentSummary() {
    return this._paymentSummary;
  }

  paymentMethodType: any;

  frequencyOptions: BtnToggleOptions[] = [];

  formOfPaymentOptions: BtnToggleOptions[] = [];

  buttonOptions = {
    buttonText: 'FINALIZAR',
    borderRadius: '25px',
    buttonBorderWidth: 'none',
    buttonBorderColor: 'none',
    buttonSize: 'btn btn-sm py-2 px-4 w-100 btn-primary',
  };

  buttonAddDependentsOptions = {
    buttonText: 'Adicionar Dependente(s)',
    buttonSize: 'btn btn-md btn-primary mt-4 w-100',
    borderRadius: '25px',
  };

  buttonAddCardOptions = {
    buttonText: '+ Adicionar cartão',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm py-2 px-5 btn-primary',
  };

  backOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px',
  };

  couponOptions = {
    buttonText: 'Aplicar',
    buttonSize: 'btn btn-md btn-primary mt-4 w-100',
    borderRadius: '25px',
  };

  showCreditCardOptions = false;
  showInstallments = false;
  subscriptionFee: number = 0;

  private _destroy$ = new Subject<void>();

  private publicPlans$?: Observable<any>;
  private planDiscountCache = new Map<string, Observable<any>>();
  private dependentsAmountCache = new Map<string, Observable<DependentsAmountModel>>();

  numberOfInstallmentsOptions: SelectModel[] = [];

  desiredOrderFrequency = [
    'TEMPORADA',
    'ANUAL',
    'SEMESTRAL',
    'TRIMESTRAL',
    'MENSAL',
  ];

  @ViewChild(DependentesModalComponent) dependentesModal!: DependentesModalComponent;

  protected planOptions = [] as SelectModel[];
  dependentsOptions = [] as SelectModel[];
  relationshipDegrees: SelectModel[] = [];

  // Dependent customization
  dependentCustomization: boolean = false;
  dependentsToContract: DependentToContract[] = [];
  existingDependents: DependentToContract[] = [];
  dependentsAmount: number = 0;
  totalDependentsValue: number = 0;

  dependentsAmountOptions = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' }
  ];

  documentTypeOptions = [
    { value: 1, label: 'CPF' },
    { value: 2, label: 'RG' }
  ];

  planItem: any;

  get showDueDay(): boolean {
    const plan = this.planItem ? this.planItem[0] : null;
    if (!plan || plan.fixedDueDate != null) {
      return false;
    }
    const formOfPayment = this.finalizePaymentformGroup.get('formOfPaymentControl')?.value;
    return formOfPayment === PaymentTypeId.CREDITO_RECORRENCIA
      || formOfPayment === PaymentTypeId.PIX_RECORRENCIA
      || formOfPayment === PaymentTypeId.PIX_PARCELADO;
  }

  get planItemAmount(): number {
    return this.planItem && this.planItem.length > 0 ? this.planItem[0].amount : 0;
  }

  plans: PlanPaymentUpgradeModel[] = [];
  jerseySizes: any[] = [];
  canAddJerseySize = false;
  jerseyModels: any[] = [];
  canCustomizeJersey = false;
  memberPlan: any;
  planSelected: any;
  benefitsPlanSelected: any;
  user: UserModel;
  deviceId: string;

  private memberId: string;
  isLoggedIn = false;

  operation: OperationType = this.paymentDataService.getOperationType();

  constructor(
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private paymentDataService: PaymentDataService,
    private router: Router,
    private memberService: MemberService,
    private planService: PlanService,
    private modalService: ModalService,
    private alertService: AlertService,
    private authService: AuthService,
    private planPaymentsService: PlanPaymentsService,
    private userService: UserService,
    private location: Location,
    private couponService: CouponService,
    private jerseySizeService: JerseySizeService,
    private jerseyModelService: JerseyModelService,
    private replaceText: ReplaceTextPipe,
    private http: HttpClient,
    private qrCodeService: QrCodeService
  ) {
    this.addScriptMercadoPago();

    this.user = this.userService.currentUserValue as UserModel;

    this.isForeigner = this.user?.isForeigner || false;

    this.authService.isLoggedIn.pipe(takeUntil(this._destroy$)).subscribe((status) => {
      this.isLoggedIn = status;
    });

    this.memberId = this.memberService.getMemberId();
    if (!this.memberId) {
      this.router.navigate(['/cadastro-socio']);
    }
  }

  ngOnInit(): void {
    this.currentUserData = this.localStorageService.getItem('current-user');
    if (!this.currentUserData) {
      console.error('Dados do usuário não encontrados no local storage.');
    }

    this.screenWidth = window.innerWidth;
    this.planSelected = this.planService.getPlanSelected();

    if (
      this.operation === OperationType.UPGRADE ||
      this.operation === OperationType.UPGRADE_RECURRENCE
    ) {
      this.planService.getCurrentPlanDetail(this.memberId).subscribe({
        next: (res: MemberPlanDetailModel) => {
          this.memberPlan = res;
          this.getPlanPaymentsUpgrades(this.memberPlan?.id);
          this.loadExistingDependents(this.memberPlan?.id);
        },
      });
    } else if (
      this.operation === OperationType.RENEW ||
      this.operation === OperationType.EARLY_RENEW
    ) {
      if (this.user?.memberSituation?.id === MemberSituationEnum.NaoRenovado) {
        if (this.planSelected) {
          const previousMemberPlansId = localStorage.getItem('previousMemberPlansId') as string;
          this.getRenewalsByPlan(previousMemberPlansId);
          this.loadExistingDependents(previousMemberPlansId);
        } else {
          this.planService.getLastExpiredMemberPlan(this.memberId).subscribe({
            next: (res: MemberPlanDetailModel) => {
              this.memberPlan = res;
              this.getRenewalsByPlan(this.memberPlan?.id);
              this.loadExistingDependents(this.memberPlan?.id);
            },
            error: (error: any) => {
              console.error('Error: ', error);
            },
          });
        }
      } else {
        this.planService.getCurrentPlanDetail(this.memberId).subscribe({
          next: (res: MemberPlanDetailModel) => {
            this.memberPlan = res;
            this.getRenewalsByPlan(this.memberPlan?.id);
            this.loadExistingDependents(this.memberPlan?.id);
          },
          error: (error: any) => {
            console.error('Error: ', error);
          },
        });
      }
    } else {
      this.getPlans();
    }

    this.jerseySizeService.getAllJerseySizes().subscribe(res => {
      this.jerseySizes = res;
    });
    this.jerseyModelService.getAllJerseyModels().subscribe(res => {
      this.jerseyModels = res;
    });

    this.reapplyCoupon$
      .pipe(debounceTime(0), takeUntil(this._destroy$))
      .subscribe(() => this.reapplyCoupon());

    // Seleção de plano
    this.finalizePaymentformGroup.controls.planControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => {
        this.couponMessage = '';
        this.showInstallments = false;
        this.onPlanChange(value as string);
        this.getSummaryInfo();
      });

    // Seleção de frequência
    this.finalizePaymentformGroup.controls.frequencyControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => {
        this.showInstallments = false;
        this.onFrequencyChange(value as string);
        this.getSummaryInfo();
      });

    // Seleção de forma de pagamento
    this.finalizePaymentformGroup.controls.formOfPaymentControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => {
        this.showInstallments = false;
        this.setPixIconColor(value as string);
        this.updateSummary(value as PaymentType);
        this.getSummaryInfo();
      });

    // Seleção de dependentes
    this.finalizePaymentformGroup.controls.dependentControl.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this.dependentsToContract = [...this.existingDependents];
        this.calculateTotalDependentsValue();
        this.updateValueWithDependents(false);
      });

    const paymentInfo = {
      plan: '',
      frequency: '',
      invoiceRecurrence: true,
      formOfPayment: '',
      creditCard: '',
      numberOfInstallments: '',
    } as PaymentInfoModel;

    this.initializeForm(this.finalizePaymentformGroup, paymentInfo);

    this.setCreditCardArr();
    this.getMemberCoupons();
  }

  getMemberCoupons() {
    if (this.memberId) {
      this.couponService.getMemberCoupons(this.memberId, OperationType[this.operation]).subscribe({
        next: (coupons: any) => {
          this.memberCoupons = coupons;
        }
      });
    }
  }

  private getPublicPlans(): Observable<any> {
    if (!this.publicPlans$) {
      this.publicPlans$ = this.planService.getPublicPlans().pipe(
        tap({ error: () => (this.publicPlans$ = undefined) }),
        shareReplay(1)
      );
    }
    return this.publicPlans$;
  }

  getPlans(): void {
    this.getPublicPlans().subscribe((plans: any) => {
      this.plans = plans.content;
      this.planOptions = [
        {
          code: '0',
          name: this.replaceText.transform('Selecione um plano'),
        } as SelectModel,
        ...(this.plans.map((plan: any) => {
          return {
            code: plan.id,
            name: plan?.planName,
          } as SelectModel;
        }) as SelectModel[]),
      ];

      if (this.planSelected?.id) {
        // Verificar se o plano pode ter novos sócios
        this.planService
          .canAddMember(this.planSelected.id, this.currentUserData.id)
          .subscribe((canAdd: boolean) => {
            if (canAdd) {
              // Mantém o plano selecionado
              this.finalizePaymentformGroup
                .get('planControl')
                ?.setValue(this.planSelected.id);
            } else {
              // Reseta para "Selecione um plano" e exibe alerta
              this.finalizePaymentformGroup.get('planControl')?.setValue('0');
              this.alertService.showAlert(
                AlertType.WARNING,
                this.replaceText.transform('O plano selecionado atingiu o limite de sócios permitidos.')
              );
            }
          });
      } else {
        // Reseta para "Selecione um plano" por padrão
        this.finalizePaymentformGroup.get('planControl')?.setValue('0');
      }
    });
  }

  addScriptMercadoPago() {
    const script = document.createElement('script');
    script.src = 'https://www.mercadopago.com/v2/security.js';
    script.setAttribute('view', 'checkout');
    script.setAttribute('output', 'deviceId');
    document.head.appendChild(script);

    script.onload = () => {
      this.deviceId =
        (window as any).deviceId || (window as any).MP_DEVICE_SESSION_ID;
    };
  }

  getRenewalsByPlan(id: string): void {
    if (!id) {
      return;
    }
    this.planPaymentsService
      .getPlanPaymentsRenewals(id)
      .subscribe((plans: PlanPaymentUpgradeModel[]) => {
        this.plans = plans;
        if (this.operation === OperationType.EARLY_RENEW) {
          this.plans = plans.filter(
            (plan) =>
              plan.paymentMethodType.id !== PaymentTypeId.CREDITO_RECORRENCIA
              && plan.paymentMethodType.id !== PaymentTypeId.PIX_RECORRENCIA
              && plan.paymentMethodType.id !== PaymentTypeId.PIX_PARCELADO
          );
        } else if (this.operation === OperationType.UPGRADE) {
          this.plans = plans.filter((plan) => plan.paymentMethodType.id !== PaymentTypeId.PIX_PARCELADO);
        }

        this.planOptions = this.plans
          .map((plan: any) => {
            return {
              code: plan.plan,
              name: plan?.planName,
            } as SelectModel;
          })
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.code === item.code)
          );

        if (this.planSelected?.id) {
          this.finalizePaymentformGroup
            .get('planControl')
            ?.setValue(this.planSelected.id);
        }
      });
  }

  getPlanPaymentsUpgrades(memberPlanId: string): void {
    if (!memberPlanId) {
      return;
    }
    this.planPaymentsService
      .getPlanPaymentsUpgrades(memberPlanId)
      .subscribe((plans: PlanPaymentUpgradeModel[]) => {
        this.plans = plans;
        this.planOptions = this.plans
          .map((plan: any) => {
            return {
              code: plan.plan,
              name: plan?.planName,
            } as SelectModel;
          })
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.code === item.code)
          );
        if (this.planSelected?.id) {
          this.finalizePaymentformGroup
            .get('planControl')
            ?.setValue(this.planSelected.id);
        }
      });
  }

  updateValueOfPayment() {
    this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue(null);
    this.showCreditCardOptions = false;
    this.paymentSummary = {};
  }

  onPlanChange(value: string): void {
    this.showCreditCardOptions = false;
    // Verifica se o plano foi selecionado
    if (!value || value === '0') {
      this.frequencyOptions = [];
      this.formOfPaymentOptions = [];
      this.finalizePaymentformGroup.controls.frequencyControl.setValue('');
      this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue('');
      this.dependentsOptions = [];
      this.planItem = null;

      this.paymentSummary = {};
      this.setJerseyRequired(false);
      this.subscriptionFee = 0;
      this.dependentCustomization = false;
      this.dependentsToContract = [...this.existingDependents];
      this.dependentsAmount = 0;
      this.totalDependentsValue = 0;
      this.showDependentsOptions = false;

      return;
    }

    const selectedPlan = this.plans.find((plan => plan.id === value || plan.plan === value));
    this.setJerseyRequired(!!selectedPlan?.includesTeamJersey);

    this.canCustomizeJersey = selectedPlan ? selectedPlan.allowsJerseyCustomization : false;
    if (this.canCustomizeJersey) {
      this.finalizePaymentformGroup.get('jerseyModelControl')?.setValidators(Validators.required);
    } else {
      this.finalizePaymentformGroup.get('jerseyModelControl')?.setValidators(null);
      this.finalizePaymentformGroup.get('personalizationNameControl')?.setValidators(null);
      this.finalizePaymentformGroup.get('personalizationNumberControl')?.setValidators(null);
    }

    const isNewPlanOperation = this.operation === OperationType.NEW || this.operation === OperationType.NEWLOGGED;
    this.subscriptionFee = isNewPlanOperation && selectedPlan?.hasSubscriptionFee
      ? (selectedPlan.subscriptionFee || 0)
      : 0;

    // Verifica se é possível adicionar membros ao plano selecionado
    this.planService.canAddMember(value, this.currentUserData.id).subscribe({
      next: (canAdd: boolean) => {
        if (!canAdd) {
          // Se não for possível adicionar membros, reseta o plano e exibe uma mensagem
          this.finalizePaymentformGroup.controls.planControl.setValue('0');
          this.alertService.showAlert(
            AlertType.WARNING,
            this.replaceText.transform('O plano selecionado atingiu o limite de sócios permitidos.')
          );
          return; // Interrompe a execução do método
        }

        if (this.finalizePaymentformGroup.controls.planControl.value !== value) {
          return;
        }

        // Se for possível, segue com a lógica do plano
        this.planItem = this.plans?.filter(
          (plan: any) => plan?.plan === value || plan?.id === value
        ) as PlanPaymentUpgradeModel[];
        this.benefitsPlanSelected = null;

        // Verificar se o plano tem customização de dependentes
        this.dependentCustomization = this.planItem[0]?.dependentCustomization || false;
        this.dependentsToContract = [...this.existingDependents];
        this.dependentsAmount = 0;
        this.totalDependentsValue = 0;

        // Tratamento para plano gratuito
        if (this.planItem[0].amount == 0) {
          this.frequencyOptions = [];
          this.formOfPaymentOptions = [];
          this.frequencyOptions = [
            {
              label: 'MENSAL',
              value: '0cebe0c2-22ee-483d-90cb-9b9f52c2ca3b',
            },
          ];
          this.finalizePaymentformGroup.controls.frequencyControl.setValue(
            '0cebe0c2-22ee-483d-90cb-9b9f52c2ca3b'
          );
          this.formOfPaymentOptions = [
            {
              label: 'Gratuito',
              value: 'ea737f0c-441b-46f6-a7d4-b139f8b16357',
            },
          ];
          this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue(
            'ea737f0c-441b-46f6-a7d4-b139f8b16357'
          );
        } else {
          this.paymentSummary = {};
          this.finalizePaymentformGroup.controls.frequencyControl.setValue('');
          this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue('');
          if (!this.planItem) {
            return;
          }
          if (this.planItem[0].payments) {
            this.frequencyOptions = this.planItem[0]?.payments.map(
              (payment: any) => {
                return {
                  label: payment.period.description,
                  value: payment.period.id,
                } as BtnToggleOptions;
              }
            );
          } else {
            this.frequencyOptions = this.planItem?.map((payment: any) => {
              return {
                label: payment.period.description,
                value: payment.period.id,
              } as BtnToggleOptions;
            });
          }

          this.frequencyOptions = this.frequencyOptions?.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.label === item.label)
          );

          this.frequencyOptions.sort((a, b) => {
            return (
              this.desiredOrderFrequency.indexOf(a.label) -
              this.desiredOrderFrequency.indexOf(b.label)
            );
          });
        }
      },
      error: (error) => {
        if (error.status === 400) {
          // Exibe a mensagem de erro e reseta o plano
          console.error('Erro ao adicionar membro:', error.error.message);
          this.finalizePaymentformGroup.controls.planControl.setValue('0');
        }
      },
    });
  }

  private setJerseyRequired(required: boolean): void {
    const jerseyControl = this.finalizePaymentformGroup.controls.jerseySizeControl;
    this.canAddJerseySize = required;
    jerseyControl.setValidators(required ? Validators.required : null);
    if (!required) {
      jerseyControl.setValue('', { emitEvent: false });
    }
    jerseyControl.updateValueAndValidity({ emitEvent: false });
  }

  onFrequencyChange(value: string): void {
    this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue('');
    this.dependentsOptions = [];
    if (!value) {
      return;
    }

    if (this.planItem[0].amount == 0) {
      if (this.finalizePaymentformGroup.controls.frequencyControl.value == '') {
        this.frequencyOptions = [
          {
            label: 'MENSAL',
            value: '0cebe0c2-22ee-483d-90cb-9b9f52c2ca3b',
          },
        ];
        this.finalizePaymentformGroup.controls.frequencyControl.setValue(
          '0cebe0c2-22ee-483d-90cb-9b9f52c2ca3b'
        );
        this.formOfPaymentOptions = [
          {
            label: 'Gratuito',
            value: 'ea737f0c-441b-46f6-a7d4-b139f8b16357',
          },
        ];
        this.finalizePaymentformGroup.controls.formOfPaymentControl.setValue(
          'ea737f0c-441b-46f6-a7d4-b139f8b16357'
        );
      }
    } else {
      this.setNumberOfInstallments(
        this.frequencyOptions.find((item) => item.value === value)?.label as string
      );

      if (this.planItem[0].payments) {

        this.formOfPaymentOptions = this.planItem[0]?.payments
          .filter((payment: any) => {
            return (
              payment.period.id ===
              this.finalizePaymentformGroup.controls.frequencyControl.value &&
              this.allowPaymentForeinger(payment)
            );
          })
          .map((paymentItem: any) => {
            // Definindo a label
            let label = paymentItem.paymentMethodType.name;

            if (
              this.screenWidth <= 470 &&
              paymentItem.paymentMethodType.name === 'Cartão de Crédito'
            ) {
              label = 'C. de Crédito'; //
            }

            const isPix =
              paymentItem.paymentMethodType.name === 'PIX' ||
              paymentItem.paymentMethodType.name === 'PIX Recorrente' ||
              paymentItem.paymentMethodType.name === 'PIX Parcelado';

            return {
              label: label,
              value: paymentItem.paymentMethodType.id,
              icon: isPix ? 'pix-darker' : 'bi bi-credit-card',
              iconComponent: isPix ? 'mat-icon' : null,
            } as BtnToggleOptions;
          });
      } else {
        this.formOfPaymentOptions = this.planItem
          ?.filter((payment: any) => {
            return (
              payment.period.id ===
              this.finalizePaymentformGroup.controls.frequencyControl.value &&
              this.allowPaymentForeinger(payment)
            );
          })
          .map((paymentItem: any) => {
            // Definindo a label
            let label = paymentItem.paymentMethodType.name;

            if (
              this.screenWidth <= 470 &&
              paymentItem.paymentMethodType.name === 'Cartão de Crédito'
            ) {
              label = 'C. de Crédito';
            }

            const isPix =
              paymentItem.paymentMethodType.name === 'PIX' ||
              paymentItem.paymentMethodType.name === 'PIX Recorrente' ||
              paymentItem.paymentMethodType.name === 'PIX Parcelado';

            return {
              label: label,
              value: paymentItem.paymentMethodType.id,
              icon: isPix ? 'pix-darker' : 'bi bi-credit-card',
              iconComponent: isPix ? 'mat-icon' : null,
            } as BtnToggleOptions;
          });
      }

      this.formOfPaymentOptions = this.formOfPaymentOptions?.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.label === item.label)
      );
    }
  }

  private isPixPayment(payment: any): boolean {
    const name = payment.paymentMethodType?.name;
    return name === 'PIX' || name === 'PIX Recorrente';
  }

  private allowPaymentForeinger(payment: any): boolean {
    if (!this.isForeigner) {
      return true;
    }

    return !this.isPixPayment(payment);
  }

  private get appliedCouponName(): string {
    return this.paymentSummary?.couponApplied ? (this.couponCode ?? '') : '';
  }

  cleanCoupon() {
    this.couponCode = null;
    this.couponResultCache.clear();
    this.couponFormGroup.controls.coupon.setValue('');
    this.couponMessage = '';
    this.placeholderCoupon = 'Selecione ou insira um cupom'
  }

  onApplyCoupon(): void {
    const couponControl = this.couponFormGroup.get('coupon');
    if (couponControl && couponControl.value) {
      if (!this.paymentSummary?.id) {
        return;
      }

      this.requestCoupon(couponControl.value.toUpperCase());
    }
  }

  private reapplyCoupon(): void {
    if (!this.couponCode || !this.paymentSummary?.id || this.paymentSummary.couponApplied) {
      return;
    }

    this.requestCoupon(this.couponCode, true);
  }

  private refreshCoupon(): void {
    if (!this.couponCode) {
      return;
    }

    if (this.paymentSummary?.couponApplied) {
      this.selectPaymentSummary();
    } else {
      this.reapplyCoupon$.next();
    }
  }

  private requestCoupon(coupon: string, automatic = false): void {
    const planPaymentId = this.paymentSummary.id;
    const previousCoupon = this.paymentSummary.couponApplied ? this.couponCode : null;
    const dependentsAmount = this.dependentCustomization ? this.totalDependentsValue : 0;
    const cacheKey = `${planPaymentId}|${coupon}|${dependentsAmount}|${this.operation}`;

    this.couponCode = coupon;
    this.placeholderCoupon = 'Cupom: ' + coupon;

    const cached = automatic ? this.couponResultCache.get(cacheKey) : undefined;
    if (cached) {
      this.handleCouponResult(coupon, planPaymentId, previousCoupon, automatic, cached);
      return;
    }

    this.couponService
      .applyCoupon(
        planPaymentId,
        coupon,
        this.currentUserData.id,
        OperationType[this.operation],
        dependentsAmount
      )
      .subscribe({
        next: (res: any) => {
          const result = { response: res };
          this.couponResultCache.set(cacheKey, result);
          this.handleCouponResult(coupon, planPaymentId, previousCoupon, automatic, result);
        },
        error: (error) => {
          const message = error?.error?.message;
          const result = { error: message || 'Não foi possível aplicar o cupom' };
          if (message) {
            this.couponResultCache.set(cacheKey, result);
          }
          this.handleCouponResult(coupon, planPaymentId, previousCoupon, automatic, result);
        }
      });
  }

  private handleCouponResult(
    coupon: string,
    planPaymentId: string,
    previousCoupon: string | null,
    automatic: boolean,
    result: { response?: any; error?: string }
  ): void {
    if (this.paymentSummary?.id !== planPaymentId || this.couponCode !== coupon) {
      return;
    }

    if (result.error !== undefined) {
      this.rejectCoupon(result.error, previousCoupon, automatic);
      return;
    }

    const res = { ...result.response };

    if (!res.id && res.couponMessage?.length > 0) {
      this.rejectCoupon(res.couponMessage, previousCoupon, automatic);
      return;
    }

    this.couponMessage = '';
    res.planName = res.planName ?? this.paymentSummary.planName;
    res.enableItems = this.paymentSummary.enableItems;

    const currentDiscount = this.paymentSummary.couponApplied
      ? (this.paymentSummary.baseDiscount || 0)
      : (this.paymentSummary.discount || 0);
    const couponDiscount = res.couponDiscount || 0; // Desconto do cupom

    res.couponTotalAmount = res.discountedAmount;
    res.baseDiscount = currentDiscount;

    if (currentDiscount > couponDiscount) {
      if (automatic) {
        this.cleanCoupon();
        this.couponMessage = 'O desconto de renovação é maior que o desconto do cupom';
        return;
      }

      this.alertService.showAlert(
        AlertType.WARNING,
        'O desconto de renovação é maior que o Desconto do cupom'
      );
      res.discount = currentDiscount; // Manter o desconto atual
      res.discountedAmount = this.paymentSummary.amount - currentDiscount;

      res.couponId = null;
      res.couponName = null;
      res.couponCpf = null;
      this.cleanCoupon();
    } else {
      res.discount = 0;
      res.discountedAmount = this.paymentSummary.amount - couponDiscount;
      res.couponApplied = true;
    }

    this.paymentSummary = { ...res };
  }

  private rejectCoupon(message: string, previousCoupon: string | null, automatic: boolean): void {
    if (previousCoupon) {
      this.restoreCoupon(previousCoupon);
    } else {
      this.cleanCoupon();
    }
    this.couponMessage = message;
  }

  private restoreCoupon(previousCoupon: string | null): void {
    this.couponCode = previousCoupon;
    this.couponFormGroup.controls.coupon.setValue(previousCoupon ?? '');
    this.placeholderCoupon = previousCoupon ? 'Cupom: ' + previousCoupon : 'Selecione ou insira um cupom';
  }

  transformCouponToUppercase(): void {
    const couponControl = this.couponFormGroup.get('coupon');
    if (couponControl && couponControl.value) {
      couponControl.setValue(couponControl.value.toUpperCase(), { emitEvent: false });
    }
  }

  setNumberOfInstallments(value: string): void {
    let maxInstallments;
    switch (value) {
      case 'ANUAL':
        maxInstallments = localStorage.getItem(
          'yearMaximumNumberInstallment'
        ) as string;
        break;
      case 'TEMPORADA':
        maxInstallments = localStorage.getItem(
          'seasonMaximumNumberInstallment'
        ) as string;
        break;
      case 'SEMESTRAL':
        maxInstallments = localStorage.getItem(
          'semiAnnualMaximumNumberInstallment'
        ) as string;
        break;
      case 'TRIMESTRAL':
        maxInstallments = localStorage.getItem(
          'quarterlyMaximumNumberInstallment'
        ) as string;
        break;
      default:
        maxInstallments = '1';
        break;
    }
    this.numberOfInstallmentsOptions = [];
    for (let index = 1; index <= parseInt(maxInstallments); index++) {
      this.numberOfInstallmentsOptions.push({
        code: index.toString(),
        name: index.toString(),
      });
    }
    this.creditCardformGroup.get('numberOfInstallmentsControl')?.setValue('1');
  }

  async handleCreditCardInfo(
    creditCardArr: CreditCardInfoModel[]
  ): Promise<CreditCardInfoModel[]> {
    if (!creditCardArr.length) {
      try {
        const fetchedData = await lastValueFrom(
          this.paymentDataService.getCreditCardInfo()
        );
        this.localStorageService.setItem('credit-card-info', fetchedData);
        return fetchedData; // Return the fetched data
      } catch (error) {
        console.error('Error fetching credit card info:', error);
        throw error;
      }
    }
    return creditCardArr; // Return existing data if no fetch needed
  }

  async setCreditCardArr() {
    try {
      const creditCardArr =
        this.commonService.getCreditCardInfoFromLocalStorage();
      const updatedArr = await this.handleCreditCardInfo(creditCardArr);
      this.creditCardInfo.set(updatedArr);
    } catch (error) {
      console.error('Error setting credit card info:', error);
      // Handle error appropriately, e.g., show an alert to the user
    }
  }

  getSummaryInfo(): void {
    this.showDependentsOptions = false;
    if (this.planItem && this.planItem[0]?.amount == 0) {
      const freePayments: any[] = this.planItem[0].payments ?? this.planItem;
      const freePayment = freePayments.find(
        (payment: any) => payment.paymentMethodType?.id === PaymentTypeId.GRATUITO
      ) ?? freePayments[0];

      this.paymentSummary = {
        id: freePayment.id,
        amount: 0,
        plan: this.planItem[0].plan ?? this.planItem[0].id,
        planName: this.planItem[0]?.planName,
        qtyDependents: 0,
        paymentMethodType: {
          id: PaymentTypeId.GRATUITO,
          name: 'Gratuito',
        },
        period: {
          id: PaymentFrequencyId.MENSAL,
          description: 'MENSAL',
        },

        enableItems: [],
      };
    } else {
      if (
        !this.finalizePaymentformGroup.get('formOfPaymentControl')?.value ||
        !this.finalizePaymentformGroup.get('planControl')?.value ||
        !this.finalizePaymentformGroup.get('frequencyControl')?.value
      ) {
        return;
      }

      if (this.planItem[0].payments) {
        this.paymentMethodType = this.planItem[0]?.payments.filter(
          (payment: any) =>
            payment.paymentMethodType.id ===
            this.finalizePaymentformGroup.get('formOfPaymentControl')?.value
        );
      } else {
        this.paymentMethodType = this.planItem?.filter(
          (payment: any) =>
            payment.paymentMethodType.id ===
            this.finalizePaymentformGroup.get('formOfPaymentControl')?.value
        );
      }

      if (this.paymentMethodType.length > 1) {
        this.paymentMethodType = this.paymentMethodType.filter(
          (payment: any) =>
            payment.period.id ===
            this.finalizePaymentformGroup.get('frequencyControl')?.value
        );
      }

      if (!this.paymentMethodType?.length) {
        return;
      }

      if (this.paymentMethodType.length > 1) {
        this.setDependentsOptions();
      } else {
        this.setDependentsOptions();
        this.paymentSummary = this.paymentMethodType.reduce(
          (prev: any, current: any) => {
            return prev.qtdInstallments < current.qtdInstallments
              ? prev
              : current;
          }
        );

        if (this.paymentSummary?.enableItems?.length == 0 || !this.paymentSummary?.enableItems) {
          this.getBenefitsByPlanId(
            this.finalizePaymentformGroup.get('planControl')?.value as string
          );
        }
      }
    }
  }

  updateValueWithDependents(openModal: boolean): void {
    const qtyDependents = parseInt(this.finalizePaymentformGroup.get('dependentControl')?.value || '0');

    if (qtyDependents <= 0) {
      this.onDependentsUpdated(this.existingDependents);
    }

    // Sempre selecionar o planPayment correspondente primeiro
    this.selectPaymentSummary();

    // Se tem customização de dependentes E selecionou dependentes, abrir modal APÓS selecionar o planPayment
    if (this.dependentCustomization && qtyDependents > 0) {
      this.dependentsAmount = qtyDependents;

      // Carregar graus de parentesco se ainda não carregou
      if (this.relationshipDegrees.length === 0) {
        this.loadRelationshipDegrees();
      }

      // Abrir modal para cadastrar dependentes
      if (openModal) {
        setTimeout(() => {
          this.openDependentsModal();
        }, 200);
      }
    }
  }

  private selectPaymentSummary(): void {
    if (!this.finalizePaymentformGroup.get('dependentControl')?.value || !this.paymentMethodType?.length) {
      return;
    }

    this.paymentSummary = this.paymentMethodType.filter(
      (payment: any) =>
        payment.qtyDependents ==
        this.finalizePaymentformGroup.get('dependentControl')?.value
    )[0];
    if (!this.paymentSummary) {
      this.paymentSummary = this.paymentMethodType.reduce(
        (prev: any, current: any) => {
          return prev.qtyDependents < current.qtyDependents ? prev : current;
        }
      );
      this.finalizePaymentformGroup
        .get('dependentControl')
        ?.setValue(this.paymentSummary.qtyDependents, { emitEvent: false });
    }
    this.paymentSummary.planName = this.planItem[0]?.planName;

    if (!this.benefitsPlanSelected) {
      this.getBenefitsByPlanId(
        this.finalizePaymentformGroup.get('planControl')?.value as string
      );
    } else {
      this.paymentSummary.enableItems = this.benefitsPlanSelected;
    }
    if (!this.creditCardformGroup.get('numberOfInstallmentsControl')?.value) {
      this.creditCardformGroup
        .get('numberOfInstallmentsControl')
        ?.setValue('1');
    }
    this.updateValueWithInstallments();
  }

  updateValueWithInstallments(): void {
    if (!this.finalizePaymentformGroup.get('dependentControl')?.value) {
      this.finalizePaymentformGroup.get('dependentControl')?.setValue('0');
    }
    if (this.creditCardformGroup.get('numberOfInstallmentsControl')?.value) {
      this.paymentSummary = this.paymentMethodType.filter(
        (payment: any) =>
          payment.qtdInstallments == this.creditCardformGroup.get('numberOfInstallmentsControl')?.value
          && payment.qtyDependents == this.finalizePaymentformGroup.get('dependentControl')?.value
      )[0];

      if (!this.paymentSummary) {
        this.paymentSummary = this.paymentMethodType
          .filter(
            (payment: any) =>
              payment.qtyDependents ==
              this.finalizePaymentformGroup.get('dependentControl')?.value
          )
          .reduce((prev: any, current: any) => {
            return prev.qtdInstallments < current.qtdInstallments
              ? prev
              : current;
          });

        this.paymentSummary.planName = this.planItem[0]?.planName;
      }

      if (!this.benefitsPlanSelected) {
        this.getBenefitsByPlanId(
          this.finalizePaymentformGroup.get('planControl')?.value as string
        );
      } else {
        this.paymentSummary.enableItems = this.benefitsPlanSelected;
      }
    }
  }

  getBenefitsByPlanId(id: string): void {
    this.getPublicPlans().subscribe((plan: any) => {
      if (!this.paymentSummary || this.finalizePaymentformGroup.get('planControl')?.value !== id) {
        return;
      }

      plan = plan.content.filter((benefit: any) => benefit.id === id)[0];
      this.paymentSummary.planName = this.planItem?.[0]?.planName;
      this.paymentSummary.enableItems = this.benefitsPlanSelected =
        plan?.benefits
          .filter((benefit: any) => benefit?.isActive)
          .map((benefit: any) => benefit?.benefitName) as string[];
    });
  }

  private setPixIconColor(value: string) {
    this.formOfPaymentOptions?.find((item) => {
      if (item.label === PaymentType.PIX) {
        let valueLabel = this.getPaymentFormLabel(value);
        if (valueLabel === PaymentType.PIX) {
          item.icon = 'pix-white';
        } else {
          item.icon = 'pix-darker';
        }
      }
    });
  }

  updateSummary(formOfPayment: PaymentType): void {
    if (!formOfPayment) return;

    let formOfPaymentLabel = this.getPaymentFormLabel(formOfPayment);
    let formOfPaymentId = formOfPayment as string;

    this.finalizePaymentformGroup.get('installments')?.setValue('1');

    if (
      (formOfPaymentId === PaymentTypeId.CREDITO ||
        formOfPaymentLabel === PaymentType.CREDITO_ABREVIADO ||
        formOfPaymentId === PaymentTypeId.CREDITO_RECORRENCIA) &&
      this.operation !== OperationType.UPGRADE_RECURRENCE
    ) {
      this.showCreditCardOptions = true;
      if (formOfPaymentId === PaymentTypeId.CREDITO_RECORRENCIA) {
        this.finalizePaymentformGroup
          .get('invoiceRecurrenceControl')
          ?.setValue(true);
        this.creditCardformGroup
          .get('numberOfInstallmentsControl')
          ?.setValue('1');
        this.creditCardformGroup.get('numberOfInstallmentsControl')?.disable();
        this.showCanUseCardControl = false;
      } else {
        this.finalizePaymentformGroup
          .get('invoiceRecurrenceControl')
          ?.setValue(false);
        this.creditCardformGroup
          .get('numberOfInstallmentsControl')
          ?.setValue('');
        this.creditCardformGroup.get('numberOfInstallmentsControl')?.enable();
        this.showCanUseCardControl = true;
      }
      this.setCreditFieldRequired();
    } else {
      this.showCreditCardOptions = false;
      this.creditCardformGroup.reset();
      this.clearCreditFieldValidators();

      if (formOfPaymentId === PaymentTypeId.PIX_PARCELADO) {
        this.showInstallments = true;
        const value = this.finalizePaymentformGroup.controls.frequencyControl.value;
        const period = this.frequencyOptions.find((item) => item.value === value)?.label as string;

        let maxInstallments;
        switch (period) {
          case 'TRIMESTRAL':
            maxInstallments = localStorage.getItem('pixQuarterlyMaximumNumberInstallment') || '3';
            break;
          case 'TEMPORADA':
            maxInstallments = localStorage.getItem('pixSeasonMaximumNumberInstallment') || '4';
            break;
          case 'SEMESTRAL':
            maxInstallments = localStorage.getItem('pixSemiAnnualMaximumNumberInstallment') || '6';
            break;
          case 'ANUAL':
            maxInstallments = localStorage.getItem('pixYearMaximumNumberInstallment') || '12';
            break;
          default:
            this.showInstallments = false;
            maxInstallments = '1';
            break;
        }

        this.numberOfInstallmentsOptions = [];
        for (let index = 1; index <= parseInt(maxInstallments); index++) {
          this.numberOfInstallmentsOptions.push({
            code: index.toString(),
            name: index.toString(),
          });
        }
      }
    }
  }

  setDependentsOptions(): void {
    this.finalizePaymentformGroup.get('dependentControl')?.setValue('0', { emitEvent: false });
    this.dependentsOptions = [];
    let qtyDependents = this.paymentMethodType?.map((payment: any) => payment.qtyDependents);
    qtyDependents = [...new Set(qtyDependents)];
    qtyDependents.sort((a: any, b: any) => a - b);
    qtyDependents.forEach((qty: any) => {
      this.dependentsOptions.push({
        code: qty.toString(),
        name: qty.toString() === '0' ? 'Sem Dependentes' : qty.toString(),
      });
    });

    let openModal = false;
    if (this.dependentsOptions.length > 1 && this.dependentsOptions.some((option) => option.code !== '0')) {
      this.finalizePaymentformGroup.get('dependentControl')?.enable({ emitEvent: false });
      this.showDependentsOptions = true;
    } else if (this.dependentsOptions.length === 1 && this.dependentsOptions[0].code !== '0') {
      openModal = true;
      this.finalizePaymentformGroup.get('dependentControl')?.setValue(this.dependentsOptions[0].code, { emitEvent: false });
      this.finalizePaymentformGroup.get('dependentControl')?.disable({ emitEvent: false });
      if (this.dependentCustomization) {
        this.showDependentsOptions = true;
      }
    }
    this.updateValueWithDependents(openModal);
  }

  save(): void {
    if (this.submitCount > 0) {
      return;
    }

    const dependents = this.dependentsToContract;
    if (this.dependentCustomization) {
      const qtyDependents = parseInt(this.finalizePaymentformGroup.get('dependentControl')?.value || '0');
      if (qtyDependents > 0 && this.dependentsToContract.length !== qtyDependents) {
        this.alertService.showAlert(
          AlertType.WARNING,
          `Você deve adicionar ${qtyDependents} dependente(s) para prosseguir.`
        );
        return;
      }
    }

    this.blockSubmit();

    if (this.operation === OperationType.UPGRADE_RECURRENCE) {
      this.sendRecurrentUpgrade();
      return;
    }

    let paymentPayload: PaymentDataPayload | PostPublicMemberPlansModel;
    let paymentType = this.getPaymentFormLabel(
      this.finalizePaymentformGroup.get('formOfPaymentControl')?.value as string
    );

    if (paymentType === PaymentType.GRATUITO) {
      paymentPayload = {
        automaticRenewal: false,
        couponId: '',
        couponName: '',
        couponCpf: '',
        discount: 0,
        earlyRenewalOrigin: false,
        installments: 0,
        memberId: this.memberId,
        memberPlanStatus: {
          id: '12b5d978-a34a-43d6-abf6-8c99b11a1573',
          name: 'Ativo',
          description: this.replaceText.transform('Plano Ativo'),
        },
        planId: this.finalizePaymentformGroup.get('planControl')?.value || '',
        planOriginId: '',
        planPaymentId: this.paymentSummary.id,
        qtyPoints: 0,
        recurrence: false,
        renewalOrigin: false,
        upgradedOrigin: false,
        jerseySizeId: null
      };
      this.postFreePlan(paymentPayload as PostPublicMemberPlansModel);
    } else {
      const installments = this.finalizePaymentformGroup.get('formOfPaymentControl')?.value === PaymentTypeId.PIX_PARCELADO
        ? parseInt(this.finalizePaymentformGroup.get('installments')?.value || '1')
        : parseInt(this.creditCardformGroup.get('numberOfInstallmentsControl')?.value || '1');

      const canUseCardValue =
        this.creditCardformGroup.get('canUseCardControl')?.value ?? false;

      const dueDayValue = this.finalizePaymentformGroup.get('dueDayControl')?.value;

      paymentPayload = {
        cardCvv: this.creditCardformGroup.get('cvvControl')?.value || '',
        cardExpirationDate:
          this.creditCardformGroup
            .get('expirationDateControl')
            ?.value?.replace(/\/(\d{2})$/, '/20$1') || '',
        cardHolderName: this.creditCardformGroup.get('cardNameControl')?.value || '',
        cardNumber: this.creditCardformGroup.get('cardNumberControl')?.value || '',
        cpf: this.creditCardformGroup.get('CPFControl')?.value || '',
        installments: installments,
        memberId: this.memberId,
        paymentMethodId: this.finalizePaymentformGroup.get('formOfPaymentControl')?.value || '',
        periodicityId: this.finalizePaymentformGroup.get('frequencyControl')?.value || '',
        planId: this.finalizePaymentformGroup.get('planControl')?.value || '',
        planPaymentId: this.paymentSummary.id,
        discount: this.paymentSummary.discount,
        planDiscountId: this.currentDiscountPlan?.id,
        operationType: this.getOperationType(this.operation),
        canUseCard: canUseCardValue,
        couponId: this.paymentSummary?.couponId,
        couponName: this.appliedCouponName,
        couponCpf: this.currentUserData.cpf || '',
        dependents: dependents.map(dep => ({ ...dep, dependentAmount: dep.configAmount || 0 })),
        jerseySizeId: this.finalizePaymentformGroup.get('jerseySizeControl')?.value || null,
        jerseyModelId: this.finalizePaymentformGroup.get('jerseyModelControl')?.value || null,
        personalizationName: this.finalizePaymentformGroup.get('personalizationNameControl')?.value || null,
        personalizationNumber: this.finalizePaymentformGroup.get('personalizationNumberControl')?.value || null,
        chargeSubscriptionFee: true,
        dueDay: dueDayValue ? Number(dueDayValue) : undefined
      };

      this.postPaidPlan(
        paymentPayload as PaymentDataPayload,
        paymentType as PaymentType
      );
    }
  }

  sendRecurrentUpgrade(): void {
    const dependents = this.dependentsToContract;

    const dueDayValue = this.finalizePaymentformGroup.get('dueDayControl')?.value;

    const paymentData: RecurrentUpgradeTO = {
      memberId: this.memberId,
      planId: this.paymentSummary.plan,
      methodId: this.finalizePaymentformGroup.get('formOfPaymentControl')?.value || '',
      planPaymentId: this.paymentSummary.id,
      recurrence: true,
      amount: this.paymentSummary.amount,
      status: 'waiting_payment',
      couponId: this.paymentSummary?.couponId,
      couponName: this.appliedCouponName,
      couponCpf: this.currentUserData.cpf || '',
      dependents: dependents.map(dep => ({ ...dep, dependentAmount: dep.configAmount || 0 })),
      jerseySizeId: this.finalizePaymentformGroup.get('jerseySizeControl')?.value || undefined,
      jerseyModelId: this.finalizePaymentformGroup.get('jerseyModelControl')?.value || undefined,
      personalizationName: this.finalizePaymentformGroup.get('personalizationNameControl')?.value || undefined,
      personalizationNumber: this.finalizePaymentformGroup.get('personalizationNumberControl')?.value || undefined,
      chargeSubscriptionFee: true,
      dueDay: dueDayValue ? Number(dueDayValue) : null
    };

    this.paymentDataService.sendRecurrentUpgrade(paymentData).subscribe(
      (data: RecurrentUpgradeTO) => {
        // Handle success, e.g., navigate to a success page
        this.router.navigate(['/finalizar-pagamento/seja-bem-vindo']);
      },
      (error) => {
        console.error('Recurrent upgrade failed', error);
        // Handle error, e.g., show an error message
        this.alertService.showAlert(
          AlertType.DANGER,
          'Erro ao processar Upgrade. Tente novamente mais tarde.'
        );
      }
    );
  }

  postFreePlan(paymentPayload: PostPublicMemberPlansModel): void {
    let freePaymentPayload: FreePaymentDataPayload;
    freePaymentPayload = {
      memberId: paymentPayload.memberId,
      planId: paymentPayload.planId,
      planPaymentId: paymentPayload.planPaymentId,
      methodId: 'ea737f0c-441b-46f6-a7d4-b139f8b16357',
    };
    this.memberService
      .postFreeMemberPlans(freePaymentPayload)
      .subscribe({
        next: (data: any) => {
          this.paymentDataService.setOperationType(
            this.operation || OperationType.NEW
          );
          this.router.navigate(['/finalizar-pagamento/seja-bem-vindo']);
        },
        error: (error) => {
          console.error('Erro ao contratar plano gratuito', error);
          this.alertService.showAlert(
            AlertType.DANGER,
            this.replaceText.transform('Não foi possível contratar o plano. Tente novamente.')
          );
        }
      });
  }

  private navigateToWelcome(delay = 0): void {
    setTimeout(() => {
      this.router.navigate(['/finalizar-pagamento/seja-bem-vindo']);
    }, delay);
  }

  private isCardPayment(methodId: string, paymentType: PaymentType): boolean {
    return methodId === PaymentTypeId.CREDITO
      || methodId === PaymentTypeId.CREDITO_RECORRENCIA
      || paymentType === PaymentType.CREDITO
      || paymentType === PaymentType.CREDITO_ABREVIADO;
  }

  postPaidPlan(paymentPayload: PaymentDataPayload, paymentType: PaymentType): void {
    paymentPayload.deviceId = this.deviceId;
    if (paymentPayload.cardCvv && paymentPayload.cardCvv.length > 3) {
      paymentPayload.cardCvv = paymentPayload.cardCvv.substring(0, 3);
    }
    this.paymentDataService.sendPaymentData(paymentPayload).subscribe(
      async (data: any) => {
        if (!data) {
          this.alertService.showAlert(
            AlertType.DANGER,
            'Pagamento não aprovado. Verifique os dados e tente novamente.'
          );
          this.creditCardformGroup.reset();
        } else if (data.code == 400) {
          this.alertService.showAlert(AlertType.DANGER, data.message);
          this.creditCardformGroup.reset();
        } else {
          if (this.isCardPayment(paymentPayload.paymentMethodId, paymentType)) {
            if (data.status === 'paid') {
              this.memberService.setMemberPlan(this.planItem);
              this.paymentDataService.setOperationType(this.operation || OperationType.NEW);

              const canUseCardValue = this.creditCardformGroup.get('canUseCardControl')?.value ?? false;
              if (canUseCardValue) {
                this.memberService
                  .updateCanUseCard(this.memberId, canUseCardValue)
                  .subscribe({
                    next: () => this.navigateToWelcome(2000),
                    error: (error) => {
                      console.error('Erro ao salvar preferência de uso do cartão', error);
                      this.navigateToWelcome(2000);
                    }
                  });
              } else {
                this.navigateToWelcome(2000);
              }
            } else if (
              data.error ||
              data.declinedCode ||
              ['failed', 'refused', 'declined', 'canceled', 'cancelled', 'error'].includes(data.status)
            ) {
              this.alertService.showAlert(
                AlertType.DANGER,
                data.message || data.error || 'Pagamento não aprovado. Verifique os dados do cartão e tente novamente.'
              );
            }
          } else {
            try {
              const invoiceCodeImg = await this.resolvePixImage(data.qrCodeImageUrl, data.qrCodeData);

              this.paymentModalData = {
                invoiceNumber: data.id,
                invoiceCode: data.qrCodeData,
                invoiceCodeImg,
              };
              this.paymentType = PaymentType.PIX;
              this.checkPixPayment(data.orderId);
              this.modalService.open(this.modalId);
            } catch (error) {
              console.error('Erro ao gerar imagem do QRCode:', error);
              this.alertService.showAlert(AlertType.DANGER, 'Não foi possível gerar o QRCode. Tente novamente.');
            }
          }
        }
      },
      (error) => {
        this.blockSubmit();
      }
    );
  }

  private async resolvePixImage(imageUrl: string, pixCode: string): Promise<string> {
    if (this.isPixPayload(imageUrl)) {
      return this.qrCodeService.generateDataUrl(imageUrl.trim());
    }

    if (imageUrl?.trim()) {
      return imageUrl;
    }

    if (this.isPixPayload(pixCode)) {
      return this.qrCodeService.generateDataUrl(pixCode.trim());
    }

    throw new Error('Resposta sem QRCode válido');
  }

  private isPixPayload(data: string | null | undefined): boolean {
    const valor = data?.trim() ?? '';
    return valor.startsWith('000201') && valor.includes('br.gov.bcb.pix');
  }

  blockSubmit() {
    this.clearSubmitInterval();
    this.submitCount = 60;
    this.submitInterval = setInterval(() => {
      this.submitCount--;
      if (this.submitCount <= 0) {
        this.submitCount = 0;
        this.clearSubmitInterval();
      }
    }, 1000);
  }

  private clearSubmitInterval(): void {
    if (this.submitInterval) {
      clearInterval(this.submitInterval);
      this.submitInterval = undefined;
    }
  }

  getOperationType(operation: OperationType): string {
    switch (operation) {
      case OperationType.UPGRADE:
      case OperationType.UPGRADE_RECURRENCE:
        return 'upgrade';
      case OperationType.RENEW:
        return 'renewal';
      case OperationType.EARLY_RENEW:
        return 'early_renewal';
      default:
        return 'subscription';
    }
  }

  checkPixPayment(orderId: any): void {
    this.paymentDataService.getPaymentOrder(orderId).subscribe((data) => {
      if (data.status != 'paid') {
        if (this.canChekPix) {
          setTimeout(() => {
            this.checkPixPayment(orderId);
          }, 3000);
        }
      } else {
        this.memberService.setMemberPlan(this.planItem);
        this.modalService.close(this.modalId);
        this.paymentDataService.setOperationType(
          this.operation || OperationType.NEW
        );
        this.router.navigate(['/finalizar-pagamento/seja-bem-vindo']);
      }
    });
  }

  openCouponModal() {
    this.modalService.open(this.couponModalId);
  }

  onCouponSelect(event: any) {
    this.couponFormGroup.get('coupon')?.setValue(event.coupon);
    this.onApplyCoupon();
  }

  private initializeForm(formGroup: FormGroup, paymentInfo: PaymentInfoModel): void {
    if (Object.keys(paymentInfo).length > 0) {
      formGroup.get('planControl')?.setValue(paymentInfo?.plan);
      formGroup.get('frequencyControl')?.setValue(paymentInfo?.frequency);
      formGroup.get('invoiceRecurrenceControl')?.setValue(paymentInfo?.invoiceRecurrence);
      formGroup.get('formOfPaymentControl')?.setValue(paymentInfo?.formOfPayment);
      formGroup.get('dependentControl')?.setValue(paymentInfo?.dependents);
      if (
        paymentInfo?.formOfPayment === PaymentType.CREDITO ||
        paymentInfo?.formOfPayment === PaymentType.CREDITO_ABREVIADO ||
        paymentInfo?.formOfPayment === PaymentType.CREDITO_RECORRENCIA
      ) {
        formGroup.get('creditCardControl')?.setValue(paymentInfo?.creditCard);
        if (paymentInfo?.formOfPayment === PaymentType.CREDITO_RECORRENCIA) {
          formGroup.get('numberOfInstallmentsControl')?.setValue('1');
        } else {
          formGroup
            .get('numberOfInstallmentsControl')
            ?.setValue(paymentInfo?.numberOfInstallments);
        }
        this.setCreditFieldRequired();
      }
    }
  }

  private setCreditFieldRequired(): void {
    this.creditCardformGroup.controls.cardNumberControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.expirationDateControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.cvvControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.cardNameControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.CPFControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.numberOfInstallmentsControl.setValidators(Validators.required);
    this.creditCardformGroup.controls.cardNumberControl.updateValueAndValidity();
    this.creditCardformGroup.controls.expirationDateControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cvvControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cardNameControl.updateValueAndValidity();
    this.creditCardformGroup.controls.CPFControl.updateValueAndValidity();
    this.creditCardformGroup.controls.numberOfInstallmentsControl.updateValueAndValidity();
  }

  private clearCreditFieldValidators(): void {
    this.creditCardformGroup.controls.cardNumberControl.setValidators(null);
    this.creditCardformGroup.controls.expirationDateControl.setValidators(null);
    this.creditCardformGroup.controls.cvvControl.setValidators(null);
    this.creditCardformGroup.controls.cardNameControl.setValidators(null);
    this.creditCardformGroup.controls.CPFControl.setValidators(null);
    this.creditCardformGroup.controls.numberOfInstallmentsControl.setValidators(null);
    this.creditCardformGroup.controls.cardNumberControl.updateValueAndValidity();
    this.creditCardformGroup.controls.expirationDateControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cvvControl.updateValueAndValidity();
    this.creditCardformGroup.controls.cardNameControl.updateValueAndValidity();
    this.creditCardformGroup.controls.CPFControl.updateValueAndValidity();
    this.creditCardformGroup.controls.numberOfInstallmentsControl.updateValueAndValidity();
  }

  getPaymentFormLabel(formOfPaymentId: string): string {
    return (
      this.formOfPaymentOptions.find(
        (payment: any) => payment.value === formOfPaymentId
      )?.label || ''
    );
  }

  getFrequencyFormLabel(formOfFrequencyId: string): string {
    return (
      this.frequencyOptions.find(
        (payment: any) => payment.value === formOfFrequencyId
      )?.label || ''
    );
  }

  onModalConfirm(): void { }

  // Métodos para gerenciar dependentes
  loadRelationshipDegrees(): void {
    this.http.get<any[]>(`${environment.publicApiSocioUrl}v1/socio/relationship-degree/select-check-box`)
      .subscribe({
        next: (degrees) => {
          this.relationshipDegrees = degrees.map(d => ({
            code: d.id,
            name: d.name
          }));
        },
        error: (error) => {
          console.error('Erro ao carregar graus de parentesco:', error);
          this.alertService.showAlert(
            AlertType.DANGER,
            'Erro ao carregar graus de parentesco'
          );
        }
      });
  }

  openDependentsModal(): void {
    // Garantir que o modal seja aberto
    setTimeout(() => {
      if (this.dependentesModal) {
        this.dependentesModal.openModal();
      }

      // Abrir modal usando Bootstrap
      setTimeout(() => {
        const modalElement = document.getElementById('dependentes-modal');
        if (modalElement) {
          const existingModal = (window as any).bootstrap.Modal.getInstance(modalElement);
          if (existingModal) {
            existingModal.show();
          } else {
            const modal = new (window as any).bootstrap.Modal(modalElement, {
              backdrop: 'static',
              keyboard: false
            });
            modal.show();
          }
        }
      }, 100);
    }, 100);
  }

  onDependentsUpdated(dependents: DependentToContract[]): void {
    this.dependentsToContract = dependents;
    this.calculateTotalDependentsValue();

    this.refreshCoupon();
  }

  calculateTotalDependentsValue(): void {
    this.totalDependentsValue = this.dependentsToContract.reduce((sum, dep) => sum + (dep.configAmount || 0), 0);
  }

  loadExistingDependents(memberPlanId: string): void {
    this.memberService.findMemberPlanDependentsData(memberPlanId).subscribe({
      next: res => {
        this.existingDependents = res.map(dep => ({ ...dep, configAmount: dep.dependentAmount || 0 }));
        this.dependentsToContract = [...this.existingDependents];
        this.calculateDependentsAmount();
      },
      error: err => {
        console.error(err);
        this.alertService.showAlert(
          AlertType.DANGER,
          this.replaceText.transform('Não foi possível carregar os dependentes de seu plano atual. Tente novamente.')
        );
      }
    });
  }

  calculateDependentsAmount(): void {
    const planPaymentId = this.paymentSummary?.id;
    const dependents = this.dependentsToContract;

    if (!this.dependentCustomization || !planPaymentId || !dependents?.length) {
      return;
    }

    const key = this.getDependentsAmountKey(planPaymentId, dependents);
    let amount$ = this.dependentsAmountCache.get(key);
    if (!amount$) {
      amount$ = this.planPaymentsService
        .calculateDependentsAmount(planPaymentId, {
          memberId: this.memberId,
          operationType: this.getOperationType(this.operation),
          dependents: dependents.map(toDependentData)
        })
        .pipe(shareReplay(1));
      this.dependentsAmountCache.set(key, amount$);
    }

    amount$.subscribe({
      next: (res: DependentsAmountModel) => {
        if (
          this.paymentSummary?.id !== planPaymentId ||
          this.getDependentsAmountKey(planPaymentId, this.dependentsToContract) !== key
        ) {
          return;
        }

        const withAmount = (list: DependentToContract[]) =>
          list.map((dep, index) => ({ ...dep, configAmount: Number(res.dependents?.[index]?.amount ?? 0) }));

        if (this.getDependentsAmountKey(planPaymentId, this.existingDependents) === key) {
          this.existingDependents = withAmount(this.existingDependents);
        }
        this.dependentsToContract = withAmount(this.dependentsToContract);

        const previousTotal = this.totalDependentsValue;
        this.calculateTotalDependentsValue();

        if (this.totalDependentsValue !== previousTotal) {
          this.refreshCoupon();
        }
      },
      error: (err) => {
        console.error(err);
        this.dependentsAmountCache.delete(key);
      }
    });
  }

  private getDependentsAmountKey(planPaymentId: string, dependents: DependentToContract[]): string {
    return `${planPaymentId}|${dependents.map(dep => dep.cpf).join(',')}`;
  }

  verifyPlanDiscount() {
    const planType = this.getOperationTypeCode(this.operation);

    if (this.paymentSummary?.id && this.memberId) {
      const planPaymentId = this.paymentSummary.id;

      let discount$ = this.planDiscountCache.get(planPaymentId);
      if (!discount$) {
        discount$ = this.planService.findDiscountByPlan(planPaymentId, this.memberId, planType).pipe(shareReplay(1));
        this.planDiscountCache.set(planPaymentId, discount$);
      }

      discount$.subscribe({
        next: res => {
          if (this.paymentSummary?.id !== planPaymentId) {
            return;
          }
          this.discountPlan = res;
          this.discountPlanPaymentId = planPaymentId;
          this.applyPlanDiscount();
        },
        error: () => this.planDiscountCache.delete(planPaymentId)
      });
    }
  }

  private getOperationTypeCode(operation: OperationType): number {
    switch (operation) {
      case OperationType.NEW:
      case OperationType.NEWLOGGED:
        return 1;
      case OperationType.RENEW:
      case OperationType.EARLY_RENEW:
      case OperationType.RECURRENCE:
        return 2;
      default:
        return 3;
    }
  }

  private get currentDiscountPlan(): any {
    return this.discountPlan
      && this.discountPlanPaymentId === this.paymentSummary?.id
      && typeof this.discountPlan.amount === 'number'
      ? this.discountPlan
      : null;
  }

  applyPlanDiscount() {
    if (!this.paymentSummary) {
      return;
    }

    if (this.paymentSummary.couponApplied) {
      return;
    }

    const currentDiscount = this.paymentSummary.discount || 0;
    const discountPlan = this.currentDiscountPlan;

    if (discountPlan) {
      if (discountPlan.amountType !== 1) {
        if (currentDiscount > discountPlan.amount) {
          this.showDiscountInfo(discountPlan, 'O desconto atual é maior que o Desconto aplicado');
        } else if (discountPlan.amount > this.paymentSummary.amount) {
          this.showDiscountInfo(discountPlan, 'O desconto atual é maior que o valor do plano');
        } else {
          this.paymentSummary.discount = discountPlan.amount;
          this.paymentSummary.discountedAmount = this.paymentSummary.amount - discountPlan.amount;
          this.paymentSummary.discountId = discountPlan.id;
        }
      }
    }
  }

  private showDiscountInfo(discountPlan: any, message: string): void {
    const key = `${this.paymentSummary?.id}|${discountPlan.id}|${message}`;
    if (this.lastDiscountAlertKey === key) {
      return;
    }
    this.lastDiscountAlertKey = key;
    this.alertService.showAlert(AlertType.INFO, message);
  }

  private getBaseAmount(): number {
    const summary = this.paymentSummary;
    const hasDiscount = (summary?.discount || 0) > 0 || (summary?.couponDiscount || 0) > 0;

    if (hasDiscount && summary?.discountedAmount != null) {
      return summary.discountedAmount;
    }
    return summary?.discountedAmount || summary?.amount || 0;
  }

  getTotalWithDependents(): number {
    const dependentsTotal = this.dependentCustomization ? this.totalDependentsValue : 0;
    return this.getBaseAmount() + dependentsTotal;
  }

  getTotalAmount(): number {
    const baseAmount = this.dependentCustomization ? this.getTotalWithDependents() : this.getBaseAmount();
    return this.subscriptionFee > 0 ? baseAmount + this.subscriptionFee : baseAmount;
  }

  getUpgradeTotal(): number {
    if (this.paymentSummary?.couponApplied && this.paymentSummary.couponTotalAmount != null) {
      return this.paymentSummary.couponTotalAmount;
    }

    const dependentsTotal = this.dependentCustomization ? this.totalDependentsValue : 0;
    return (this.paymentSummary?.upgradeAmount || 0) + dependentsTotal;
  }

  ngOnDestroy(): void {
    // Emit a signal to unsubscribe from the observable
    this._destroy$.next();
    this._destroy$.complete();
    this.canChekPix = false;
    this.clearSubmitInterval();
  }

  back() {
    this.location.back();
  }

  public get controls() {
    return this.finalizePaymentformGroup.controls;
  }
}

export enum OperationType {
  NEW = 0,
  UPGRADE = 1,
  DOWNGRADE = 2,
  NEWLOGGED = 3,
  RENEW = 4,
  EARLY_RENEW = 5,
  UPGRADE_RECURRENCE = 6,
  RECURRENCE = 7,
}
